<template>
    <div>
        <v-container grid-list-md justify-start>
            <v-layout>
                <v-flex xs12>
                    <div class="title mb-2">Calendar</div>
                    <v-divider></v-divider>
                </v-flex>
            </v-layout>
        </v-container>
        <v-container pt-0>
            <v-layout wrap>
                <v-flex sm4 xs12 class="text-sm-left text-xs-center">
                    <v-btn v-on:click="$refs.calendar.prev()">
                        <v-icon dark left>keyboard_arrow_left</v-icon>Prev
                    </v-btn>
                </v-flex>
                <v-flex sm4 xs12 class="text-xs-center">
                    <v-select v-model="selectedTeam" v-bind:items="teams" label="Team"></v-select>
                </v-flex>
                <v-flex sm4 xs12 class="text-sm-right text-xs-center mb-3">
                    <v-btn v-on:click="$refs.calendar.next()">
                        Next
                        <v-icon right dark>keyboard_arrow_right</v-icon>
                    </v-btn>
                </v-flex>
                <v-flex xs12 class="mb-3">
                    <v-sheet height="900">
                        <v-calendar
                            v-model="start"
                            ref="calendar"
                            v-bind:type="type"
                            v-bind:end="end"
                            color="primary"
                        >
                            <template v-slot:day="{ date }">
                                <template v-for="event in eventsMap[date]">
                                    <div
                                        v-if="event.date"
                                        v-ripple
                                        class="month-event"
                                        v-html="event.title"
                                    ></div>
                                </template>
                            </template>
                        </v-calendar>
                    </v-sheet>
                </v-flex>
                <v-flex sm6 xs12 class="text-sm-left text-xs-center">
                    <v-btn v-on:click="$refs.calendar.prev()">
                        <v-icon dark left>keyboard_arrow_left</v-icon>Prev
                    </v-btn>
                </v-flex>
                <v-flex sm6 xs12 class="text-sm-right text-xs-center">
                    <v-btn v-on:click="$refs.calendar.next()">
                        Next
                        <v-icon right dark>keyboard_arrow_right</v-icon>
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
export default {
    data() {
        return {
            today: this.$moment().format('YYYY-MM-DD'),
            start: this.$moment().format('YYYY-MM-DD'),
            end: '2019-08-31',
            type: 'month',
            selectedTeam: 'All'
        }
    },
    computed: {
        teams() {
            let teamNames = this.$store.getters.getMatchTeams
                .map((team) => {
                    return { text: team.team, value: team.team }
                })
                .sort((a, b) => {
                    if (a.text > b.text) {
                        return 1
                    } else if (a.text < b.text) {
                        return -1
                    } else {
                        return 0
                    }
                })

            teamNames.unshift({ text: 'All', value: 'All' })

            return teamNames
        },
        events() {
            if (this.selectedTeam === 'All') {
                return this.$store.getters.getCalendarEntries
            } else {
                return this.$store.getters.getCalendarEntries.filter((e) => {
                    if (e.awayTeam === this.selectedTeam) {
                        return true
                    } else if (e.homeTeam === this.selectedTeam) {
                        return true
                    } else {
                        return false
                    }
                })
            }
        },
        eventsMap() {
            const map = {}
            this.events.forEach((e) => (map[e.date] = map[e.date] || []).push(e))
            return map
        }
    }
}
</script>

<style>
.month-event {
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
}

.week-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;

    &.with-time {
        position: absolute;
        right: 4px;
        margin-right: 0px;
    }
}
</style>
